import { Product, Variant } from './types';
import { logProductViewEvent, logAddProductToCartEvent as logAddToCartGA4 } from './analytics';
import { trackAddToCartConversion } from './analytics/conversions';

/* eslint-disable camelcase */

type ProductResultConfig = {
  'productHandle': string;
  'variantId': number;
  'resultTitle': string;
  'resultBody': string;
};

type ExtendedJSONProduct = Product & {
  sizeOptions: string[];
  productGrowerDataMF?: {
    grower_product_title: string;
  }
};

type PotProduct = {
  id: string;
  product_id: string;
  product_name: string;
  product_vendor: string;
  variant_name: string;
  variant_id: string;
  product_handle: string;
  Size: string;
  Color: string;
  available: boolean;
  inventory_quantity: string;
  price: number;
  compare_at_price: number;
  isGrower: boolean;
  tags: string[]
};

type CartItem = {
  id: number;
  quantity: string | number;
  properties: Record<string, unknown>,
};

/* eslint-enable camelcase */

// eslint-disable-next-line camelcase, no-underscore-dangle
declare const __matching_products__ : ExtendedJSONProduct[];
declare const gtag: (a: unknown, b: unknown, c: unknown) => void;
declare const Glide: { new (selector: string, options: Record<any, any>): any};

(() => {
  const calcSubmitBtn: HTMLElement = document.querySelector('.jc-submit-btn');
  const backToCalcNav: HTMLElement = document.querySelector('.jc-back-nav');
  const calculatorFormCtr: HTMLElement = document.querySelector('.jungle-calc-hero');

  const jungleCalcQuiz = JSON.parse(document.querySelector('[data-jungle-calc-quiz]').innerHTML);
  const jungleCalcResultsSection = document.getElementById('shopify-section-jungle-calc-result');
  const selectEls: NodeListOf<HTMLSelectElement> = document.querySelectorAll('.jc-question__item-select');

  const validateForm = () => {
    if ([...selectEls].some((selectEl) => !selectEl.value)) {
      calcSubmitBtn.setAttribute('disabled', 'disabled');
      return;
    }

    calcSubmitBtn.removeAttribute('disabled');
  };

  /* eslint-disable camelcase, no-underscore-dangle */
  function sendGtag(items: CartItem[]) {
    const gtagItems = [];
    let price = 0;

    for (let i = 0; i < items.length; i += 1) {
      const item = items[i];
      if (item.properties && item.properties._product_id) {
        price += (item.properties._price as number) ?? 0;
        gtagItems.push({
          id: item.properties._product_id as number,
        });
      }
    }

    price /= 100;

    trackAddToCartConversion(gtagItems, price);
  }
  /* eslint-enable camelcase, no-underscore-dangle */

  const getMatchingProduct = () => {
    const selectedProductEl = document.querySelector('[data-product-handle].visible') as HTMLElement;
    const selectedProductHandle = selectedProductEl.getAttribute('data-product-handle');

    return __matching_products__.find(
      (p) => p.handle === selectedProductHandle,
    ) as ExtendedJSONProduct;
  };

  const getPlantVariant = (matchingProduct: ExtendedJSONProduct) => {
    const selectedProductEl = document.querySelector('[data-product-handle].visible') as HTMLElement;
    const selectedVariantId = selectedProductEl.getAttribute('data-variant-id') as string;
    return matchingProduct.variants.find(
      (variant) => variant.id === parseInt(selectedVariantId, 10),
    ) as Variant;
  };

  const getPotVariant = (
    availablePotsForJungleBundle: PotProduct[],
    plantVariantSize: string,
  ) => availablePotsForJungleBundle.find(
    ({ Size: potSize }) => potSize === plantVariantSize,
  ) as PotProduct;

  const getPotsForMatchingJungleBundle = (matchingProduct: ExtendedJSONProduct): PotProduct[] => {
    const potArray = [];

    for (let i = 0; i < matchingProduct.sizeOptions.length; i += 1) {
      potArray.push({
        id: `grower-${i}`,
        product_id: 'grower',
        product_name: 'Grower',
        variant_name: 'Grower / Varies',
        product_vendor: matchingProduct.vendor,
        variant_id: 'grower',
        product_handle: 'grower',
        Size: `${matchingProduct.sizeOptions[i]}`,
        Color: 'Varies',
        available: true,
        inventory_quantity: '99999',
        price: 0,
        compare_at_price: 0,
        isGrower: true,
        tags: [],
      });
    }

    return potArray;
  };

  const getQuantity = (variantId: number) => (document.querySelector(
    `input[name='quantity'][id='quantity-input-${variantId}']`,
  ) as HTMLSelectElement).value;

  const escapeTerm = (term: string) => {
    try {
      return term.trim().toLowerCase().replace(/\s/g, '-').replace(/_/g, '-');
    } catch (err) {
      return term;
    }
  };

  const getConfigID = (potVariant: PotProduct) => {
    const size = potVariant.Size;
    const pot = potVariant.product_handle;
    const color = potVariant.Color;

    return `${escapeTerm(size)}--${escapeTerm(pot)}--${escapeTerm(color)}`;
  };

  const getProductConfigImage = (potVariant: PotProduct) => {
    let image = null;
    const configID = getConfigID(potVariant);
    const productSlide = $('.product-overview__slider-wrapper').find(`[data-config-id='${configID}']`);
    if (productSlide) {
      const imgEl = $(productSlide).find('a');
      if (imgEl) {
        image = $(imgEl).attr('href');
      }
    }

    return image;
  };

  const getGrowerName = (matchingProduct: ExtendedJSONProduct) => {
    let growerName = null;

    if (matchingProduct.productGrowerDataMF
       && matchingProduct.productGrowerDataMF.grower_product_title) {
      growerName = matchingProduct.productGrowerDataMF.grower_product_title;
    }

    return growerName;
  };

  const updateAvailability = (plantVariant: Variant) => {
    const isAvailable = plantVariant.available;
    const selectedProductEl = document.querySelector('[data-product-handle].visible');
    const bundleVariantId = selectedProductEl.getAttribute('data-variant-id');

    const submitBtnEl = document.getElementById(`add-jungle-bundle-form-${bundleVariantId}`);
    const bisTriggerEl: HTMLElement = selectedProductEl.querySelector('.klaviyo-bis-trigger');

    if (isAvailable) {
      if (bisTriggerEl) {
        bisTriggerEl.style.display = 'none';
      }
      submitBtnEl.style.display = 'flex';
    } else {
      if (bisTriggerEl) {
        bisTriggerEl.style.display = 'flex';
      }
      submitBtnEl.style.display = 'none';

      if (bisTriggerEl) {
        bisTriggerEl.innerHTML = '<span class="product-form-submit-text">Out of Stock</span>'
          + '<span class="bullet-divider">&bull;</span>'
          + '<span class="get-notified">Get Notified</span>';
        bisTriggerEl.classList.add('disabled');
      }
    }
  };

  const updateForm = () => {
    const matchingProduct = getMatchingProduct();
    const availablePotsForJungleBundle = getPotsForMatchingJungleBundle(matchingProduct);
    const plantVariant = getPlantVariant(matchingProduct);
    const plantVariantSize = plantVariant.options[0];
    const potVariant = getPotVariant(availablePotsForJungleBundle, plantVariantSize);

    updateAvailability(plantVariant);

    const configID = getConfigID(potVariant);
    if (configID) {
      $(window).trigger('updateProductSlider', configID);
    } else if (plantVariant.featured_image) {
      const imageIndex = plantVariant.featured_image.position - 1;
      $(window).trigger('setInitialSlide', imageIndex);
    }

    $(window).trigger('refresh-placements');
  };

  const assembleItems: () => CartItem[] = () => {
    const matchingProduct = getMatchingProduct();
    const availablePotsForJungleBundle = getPotsForMatchingJungleBundle(matchingProduct);

    const plantVariant = getPlantVariant(matchingProduct);
    const plantVariantSize = plantVariant.options[0];
    const potVariant = getPotVariant(availablePotsForJungleBundle, plantVariantSize);

    const quantity = getQuantity(plantVariant.id);
    const packQuantity = 1;

    const image = getProductConfigImage(potVariant);
    const growerName = getGrowerName(matchingProduct);

    return [
      {
        id: plantVariant.id,
        quantity,
        properties: {
          image,
          _itemsInPack: packQuantity,
          _product_id: matchingProduct.id,
          _price: plantVariant.price,
          ...(growerName ? {
            _grower_name: growerName,
          } : {}),
        },
      },
    ];
  };

  const addJungleBundleToCart = () => {
    const data = { items: assembleItems() };

    CartJS.addItems(data.items, {
      success: () => {
        $(window).trigger('cart-drawer-open', { reload: true });
        sendGtag(data.items);
      },
      error: (jqXHR: unknown, textStatus: string, errorThrow: string) => {
        console.log('textStatus', textStatus);
        console.log('errorThrow', errorThrow);
        alert('error occurred');
      },
    });
  };

  const handleBundleAddToCartSubmit = (e: Event) => {
    e.preventDefault();
    addJungleBundleToCart();
  };

  const toggleCalculator = (toShow: boolean) => {
    calculatorFormCtr.classList[toShow ? 'remove' : 'add']('hidden');
  };

  const resetCalcForm = () => {
    const visibleBundleAddToCartForm = jungleCalcResultsSection.querySelector('[data-product-handle].visible');

    if (visibleBundleAddToCartForm) {
      const bundleVariantId = jungleCalcResultsSection.querySelector('[data-product-handle].visible').getAttribute('data-variant-id');
      const jungleBundleForm = document.getElementById(`jungle-bundle-form-${bundleVariantId}`);
      jungleBundleForm.removeEventListener('submit', handleBundleAddToCartSubmit);
      visibleBundleAddToCartForm.classList.remove('visible');

      document.querySelectorAll('[data-article-handle].visible').forEach((article) => {
        article.classList.remove('visible');
      });

      document.querySelectorAll('[data-collection-handle].visible').forEach((collection) => {
        collection.classList.remove('visible');
      });

      document.querySelectorAll('[data-parent-product-handle].visible').forEach((relatedProducts) => {
        relatedProducts.classList.remove('visible');
      });

      jungleCalcResultsSection.classList.remove('visible');

      if (global.mobileCheck()) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
    }

    selectEls.forEach((selectEl) => {
      // eslint-disable-next-line no-param-reassign
      selectEl.value = '';
    });

    toggleCalculator(true);
  };

  const renderMatchingBlogsAndCollections = () => {
    const { selectOptions: roomAnswers }: {selectOptions: string[]} = jungleCalcQuiz.questions[0];
    const roomAnswer = selectEls[0].value;
    const roomAnswerIndex = roomAnswers.findIndex((a) => roomAnswer === a);

    let matchingBlogs: string[] = [];
    let matchingCollections: string[] = [];

    if (roomAnswerIndex !== -1) {
      matchingBlogs = jungleCalcQuiz.blogResults[roomAnswerIndex];
      matchingCollections = jungleCalcQuiz.collectionResults[roomAnswerIndex];

      // Render matching blog
      matchingBlogs.forEach((blogHandle) => {
        const blogEl = document.querySelector(`[data-article-handle="${blogHandle}"]`);

        if (blogEl) {
          blogEl.classList.add('visible');
        }
      });

      // Render matching collection/s
      matchingCollections.forEach((collectionHandle) => {
        const collectionEl = document.querySelector(`[data-collection-handle="${collectionHandle}"]`);

        if (collectionEl) {
          collectionEl.classList.add('visible');
        }
      });
    }
  };

  const renderMatchingAccessories = (matchingProductConfig: ProductResultConfig) => {
    const relatedAccessoriesEl = jungleCalcResultsSection.querySelector(`[data-parent-product-handle="${matchingProductConfig.productHandle}"]`);
    relatedAccessoriesEl.classList.add('visible');

    const windowWidth = window.innerWidth;

    if (windowWidth < 1025) {
      if (document.querySelector(`.glide--${matchingProductConfig.productHandle}`)) {
        const glideAccessories = new Glide(`.glide--${matchingProductConfig.productHandle}`, {
          type: 'slider',
          perView: 1,
          startAt: 0,
          autoplay: false,
          gap: 12,
          peek: {
            before: 25,
            after: 25,
          },
        });
        glideAccessories.mount();
      }
    }
  };

  const renderMatchingProductAndAccessories = () => {
    const { selectOptions: roomSizeAnswers } :
      {selectOptions: string[]} = jungleCalcQuiz.questions[1];
    const { selectOptions: petsAnswers }: {selectOptions: string[]} = jungleCalcQuiz.questions[2];

    const roomSizeAnswer = selectEls[1].value;
    const petsAnswer = selectEls[2].value;
    const roomSizeAnswerIndex = roomSizeAnswers.findIndex((a) => roomSizeAnswer === a);
    const petsAnswerIndex = petsAnswers.findIndex((a) => petsAnswer === a);

    let matchingProductConfig: ProductResultConfig = null;

    if (roomSizeAnswerIndex !== -1 && petsAnswerIndex !== -1) {
      matchingProductConfig = jungleCalcQuiz.productResults[roomSizeAnswerIndex][petsAnswerIndex];

      jungleCalcResultsSection.classList.add('visible');
      const selectedProductEl = jungleCalcResultsSection.querySelector(`[data-product-handle="${matchingProductConfig.productHandle}"][data-variant-id="${matchingProductConfig.variantId}"]`);
      selectedProductEl.classList.add('visible');

      (jungleCalcResultsSection.querySelector('.jc-result-item-title') as HTMLElement).innerText = matchingProductConfig.resultTitle;
      (jungleCalcResultsSection.querySelector('.jc-result-item-body') as HTMLElement).innerText = matchingProductConfig.resultBody;

      renderMatchingAccessories(matchingProductConfig);

      const matchingVariantId = matchingProductConfig.variantId;
      const jungleBundleForm = document.getElementById(`jungle-bundle-form-${matchingVariantId}`);
      jungleBundleForm.addEventListener('submit', handleBundleAddToCartSubmit);
    }
  };

  const handleCalcSubmit = () => {
    toggleCalculator(false);
    renderMatchingBlogsAndCollections();
    renderMatchingProductAndAccessories();
    updateForm();

    if (global.mobileCheck()) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  const initCalculator = () => {
    resetCalcForm();

    selectEls.forEach((selectEl) => {
      selectEl.addEventListener('change', validateForm, false);
    });

    calcSubmitBtn.addEventListener('click', handleCalcSubmit, false);
    backToCalcNav.addEventListener('click', resetCalcForm, false);
  };

  initCalculator();
})();
